//fs functions url - test
const FS_FUNCTIONS_URL = 'https://us-central1-opteva-direct-test.cloudfunctions.net/';

//fs functions url - production
//const FS_FUNCTIONS_URL = 'https://us-central1-opteva-direct-454d2.cloudfunctions.net/';


var constants = {
  MOCK_VERSION: '1.7.37.Web',
  ENVIRONMENT: 'Staging',
  FS_FUNCTIONS_URL: FS_FUNCTIONS_URL,


  // FIREBASE_CONFIG:{
  //   apiKey: "AIzaSyC4CGZ3OBe3kZOOp1ZR-XU20gHO8pB3qUA",
  //   authDomain: "opteva-direct-test.firebaseapp.com",
  //   databaseURL: "https://opteva-direct-test.firebaseio.com",
  //   projectId: "opteva-direct-test",
  //   storageBucket: "opteva-direct-test.appspot.com",
  //   messagingSenderId: "762920790256"
  // },

  // SCANDIT_KEY: "ATSsS4WBEWVWFabwThws+xhCeCR9MflmUEUlFCRF3IsNTnq6lUM0kugNi9DnAzJe6xjzuaBH/4gsdmdAMUk9RHxwZc8zb1QWgRYiraxEnjasVTpARmz5QFx6vZJjHnPclDOEiYw8/jwD6PnE0gZ5ENX1X20uqQx93H4woWZoCeUw0zFhqWZAX5T1e/duJ/zeXKmSo7nCRwyDNpqS6SIaEJTOBy4iNleucgE6cPmR1dmRIbnJkBDOXlZzL1tFd2wG3wcJbKxpgCIearTI7YLPxNce/UCVBzvAuT1aJ+grjARwFxpk7XO3ujV6SBJpMc7ANDTqioWrVhSJJHWQnXrbDs3MCsp+kk83h3SGt0LphQ4PFFr80vf/E6+G6/NKwlECVsDC5KAwlgzT37fYFjNnVniXDCvUuhZKxFIzterSVP0J8M2Elh28KjVSrvwK8HknyiD/PSdkL5anPDsNLwD+ZO+eAflH/lwYLSt2WOqWKADSNYZ/7HGC263wBPeKBdIYxj+MjInMLN4SSaTOgl9+JqOKUtWNH4CHhZmEKaLmea9a73pagBDBbWprJpxrRo+AMFzbWl+hWkgMI4ngcTNj6XDrEbPO04MDZQhmS8+IRPFU7crZqz7qvCcjito6HddKF1+7/+s98ub+FwjsvvR42dmNVtLfsHrkRG3ORNkm9rUP+dIEHlsvyx0dLiVbqtBdemotovYg6sreWClfS3+L65Ah6bg/aPRw3+/rrZpkzmZKw+iGgpWMHKRbltk4qHGxhqVFDOF+7I7koreNeqH7YjT04kET4vXbSAFyWe4CQIWzjkdQskU=",

  FIREBASE_CONFIG:{
    apiKey: "AIzaSyCD5fMP3dOAQASIXEqEU5YbMFIJBIKn41g",
    authDomain: "opteva-direct-454d2.firebaseapp.com",
    databaseURL: "https://opteva-direct-454d2.firebaseio.com",
    projectId: "opteva-direct-454d2",
    storageBucket: "opteva-direct-454d2.appspot.com",
    messagingSenderId: "731313136041"
  },

  // // TestFlight Production App
  // SCANDIT_KEY: "Ad2bAquBP6qsMlwANi70PRkA+TCTH2eDJ0JSXXt9U/T/XvgljUWsqRgj+3USdcJwdW+yPYhkOX7tcEZDSV10K19iyga2eiHIjS9ejhJIwGO1LMOH3XRSECBSyhNlZdK1lSAFmd5jqeVGJV+7pu60h8f5gN+Jaw+ONDaqHtunM6uKmgwy6wX6mmUuv8DgrMfyhvADqJ7HqNAlHcCr7Redzik/KDAAKfTnFTvfmZ2rR3ih67MRXI8EIyeMmdKtH0aijcVfb/K7GnExMJuibShDFEAn1k1VYoIFoY1aq5ln9YIBRLcXHn6N3N2tcvmTrjigtqPR3WCnCeEI6AwsOv3YzRCOQqZ90WC8nGXRTiw7al+fA+/3n4waDY08Bi+mcEeiFbImz/QjP6RYcb+g2bMDfbmm/HcbDW+wkbAIRWoL7uzQLj0PsjXzrAZRlN82kFsxQfk0iUzoofyssW/WtawUYeo+InZz6IpJ8GbIX50td5oxyIyKII2OL+ElLSg529xexm896cq+CHc0rmDxD3T9NSXAA+JCptdYjm0Qf7TmjfkMv3c2XSRV9t8awGsdYEoGW2o41uskAP0WL1jIF7ImJQczrtz+X6WHVVjMDuYq3XVVT0U6DBm6wmlE7T3TcYBeZIedbMtle0XEQFDRQcyoMHnsd6TDVuGO7uwyWax5oziQJZdtP8QgPX/947drCtiLX30CbGgm6+nXtyrtKmqsEup4c9zxWPT/SEPX+R/Tur2LgQ2B4nZeYTHCJ6bGUUw0DxnbDZ2siCHM/FLqqTdKlzZZxmuIkAx+UeunwZSMddoQwyM=",
  
  // MDM Production App
  SCANDIT_KEY: "ATSsS4WBEWVWFabwThws+xhCeCR9MflmUEUlFCRF3IsNTnq6lUM0kugNi9DnAzJe6xjzuaBH/4gsdmdAMUk9RHxwZc8zb1QWgRYiraxEnjasVTpARmz5QFx6vZJjHnPclDOEiYw8/jwD6PnE0gZ5ENX1X20uqQx93H4woWZoCeUw0zFhqWZAX5T1e/duJ/zeXKmSo7nCRwyDNpqS6SIaEJTOBy4iNleucgE6cPmR1dmRIbnJkBDOXlZzL1tFd2wG3wcJbKxpgCIearTI7YLPxNce/UCVBzvAuT1aJ+grjARwFxpk7XO3ujV6SBJpMc7ANDTqioWrVhSJJHWQnXrbDs3MCsp+kk83h3SGt0LphQ4PFFr80vf/E6+G6/NKwlECVsDC5KAwlgzT37fYFjNnVniXDCvUuhZKxFIzterSVP0J8M2Elh28KjVSrvwK8HknyiD/PSdkL5anPDsNLwD+ZO+eAflH/lwYLSt2WOqWKADSNYZ/7HGC263wBPeKBdIYxj+MjInMLN4SSaTOgl9+JqOKUtWNH4CHhZmEKaLmea9a73pagBDBbWprJpxrRo+AMFzbWl+hWkgMI4ngcTNj6XDrEbPO04MDZQhmS8+IRPFU7crZqz7qvCcjito6HddKF1+7/+s98ub+FwjsvvR42dmNVtLfsHrkRG3ORNkm9rUP+dIEHlsvyx0dLiVbqtBdemotovYg6sreWClfS3+L65Ah6bg/aPRw3+/rrZpkzmZKw+iGgpWMHKRbltk4qHGxhqVFDOF+7I7koreNeqH7YjT04kET4vXbSAFyWe4CQIWzjkdQskU=",

  PHOTO_SETTINGS: {
    quality: 50,
    encodingType: 0,
    targetWidth: 1024,
    targetHeight: 1024,
    correctOrientation: true,
    allowEdit: false
  },

  GALLERY_SETTINGS: {
    quality: 20,
    destinationType: 0,
    sourceType: 0,
    encodingType: 0,
    targetWidth: 1024,
    targetHeight: 1024,
    correctOrientation: true,
    allowEdit: false
  },

  GPS_SETTINGS: {
    maximumAge: 15000,
    timeout: 15000,
    enableHighAccuracy: true
  }, 

};

var Global = {
  client_id: 'opteva-direct',
  grant_type: 'password',
  profile: null,
  access_token: null,
  access_token_name: null,
  provinces: [
    { short: "AB", name: "Alberta", country: "CA" },
    { short: "BC", name: "British Columbia", country: "CA" },
    { short: "MB", name: "Manitoba", country: "CA" },
    { short: "NB", name: "New Brunswick", country: "CA" },
    {
      short: "NL",
      name: "Newfoundland and Labrador",
      country: "CA",
      alt: ["Newfoundland", "Labrador"]
    },
    { short: "NS", name: "Nova Scotia", country: "CA" },
    { short: "NU", name: "Nunavut", country: "CA" },
    { short: "NT", name: "Northwest Territories", country: "CA" },
    { short: "ON", name: "Ontario", country: "CA" },
    { short: "PE", name: "Prince Edward Island", country: "CA" },
    { short: "QC", name: "Quebec", country: "CA" },
    { short: "SK", name: "Saskatchewan", country: "CA" },
    { short: "YT", name: "Yukon", country: "CA" }
  ],
};

export let AppConfig = {
  //getFormmatedDate: getFormattedDateOf,
  Global: Global,
  constants: constants
}





// WEBPACK FOOTER //
// ./src/providers/config.ts